import { apiInstance } from "../../../common/api/apiClient";
import { findCompanyId } from "../../../../../infrastructure/repository/company-repository";
import { GetBenefitModelsDTO } from "../../types/GetBenefitModelsDTO";

const getBenefitModels = async () => {
  const companyId = findCompanyId();

  const { data }: { data: GetBenefitModelsDTO[] } = await apiInstance.get(
    `/v1/companies/${companyId}/benefits`,
    {}
  );

  // @ts-ignore
  return data;
};

export default getBenefitModels;
